import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const PageSectionContainer = styled.div`
    color: #333;
    background-color: lightgrey;
    border-color: #ddd;
    padding: 4px 4px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 5px;
    margin-top: 5px;
  & h3 {
    font-size: 1.4em;
    margin-top: 10px;
    margin-bottom: 5px;
  }
`;

const PageSection = ({title, small, children, className}) => (
  <div className={className}>
    {title && (
      <PageSectionContainer>
        {small ? <h4>{title}</h4> : <h3>{title}</h3>}
      </PageSectionContainer>
    )}
    {children}
  </div>
);

PageSection.defaultProps = {
  small: false
};

PageSection.propTypes = {
  title: PropTypes.string,
  small: PropTypes.bool,
};

export default PageSection;


// WEBPACK FOOTER //
// ./src/components/PageSection.js